$.fn.hasExtension = function(exts) { 
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test($(this).val());
}

// Subscribe MailChimp

function validateEmailMC(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

String.prototype.isEmpty = function() {
    return (this.length === 0 || !this.trim());
};

function subscribeMC(){
  //return false;
 var subEmailMC = $('#subscribeMailChimpExclusive').val();
 
 $('.subscribeMailChimpErr').html('');
 if( validateEmailMC(subEmailMC) )
 {
   $('.subscribeMailChimpLoader').show();
   $.ajax({
     type: 'POST',
     url: 'https://rangempls.com/merchology/subscribe-canadian.php',
     data: {'MERGE0':  subEmailMC },
     success: function(data) { 
       $('.subscribeMailChimpLoader').hide();
       $('#subscribeMailChimpExclusive').val(''); 
       $('.subscribeMailChimpErr').html(data);  
     },
     error: function(XMLHttpRequest, textStatus) {
       $('.subscribeMailChimpLoader').hide();
       $('.subscribeMailChimpErr').html('<p class="error">Something is wrong.Please try again!</p>');
     }
   });
 }
 else
 {
   $('.subscribeMailChimpErr').html('<p class="error">Please enter valid email address!</p>');
 }
}


// Create Cookie

function createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

// Get Cookie

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}

function share_fb(url) {
  window.open('https://www.facebook.com/sharer/sharer.php?u='+url,'facebook-share-dialog',"width=626,height=436")
}

equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   
   /* if( $el.hasClass('scaleOnHover') )
     $el.removeClass('scaleOnHover'); */
   
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
   
   /* if( !$el.hasClass('scaleOnHover') )
     $el.addClass('scaleOnHover'); */
 });
}

var winHeight = "";
var winWidth = "";

function countHeights(){
	winHeight = $(window).height();
	winWidth = $(window).width();
}


var mobileMenuHeight = function(){
  	countHeights();
    $('.mobile-menu-accordion').css({'max-height':winHeight})
}

/**/
var shortHeight = function(){
  	countHeights();
    $('#sort-by-list, .select-attrs').css({'max-height':winHeight-95})
}

var tabHeights = function(){
    countHeights();
    $('#details, #delivery, .productReview ').css({'max-height':winHeight})
}




var headerHeight = "";
function bodyTopPadding(){
  headerHeight = $('header.header').outerHeight();
  
  if( $(window).width() <= 767 ){
    $('body').css({'padding-top':headerHeight});
  } else {
    $('body').css({'padding-top':0});
  }
  
}


/**/

/**/
jQuery(window).load(function() {
  equalheight('.equalheight');
  equalheight('.pro-cat-box');
  setTimeout(function(){
    $(window).trigger('resize');  
  },500); 
  
  
  $('body').addClass('secLoading');
    //mobileMenuHeight();
  
  $('.account-box').addClass('scaleOnHover');
  
});


jQuery(window).resize(function(){
   // mobileMenuHeight();
  //console.log("resize");
  equalheight('.equalheight');
  equalheight('.pro-cat-box');
    shortHeight();
    tabHeights();
  bodyTopPadding();
});


jQuery(document).ready(function () {
  
  bodyTopPadding();
    shortHeight();
    tabHeights();
  
 
  if (!$( "#content-mobile" ).length ) {
   $('.page-control h3 .arrow').hide(); 
  }
  
  

 $('.main-nav a, .mobile-menu-accordion a').each(function(){
  if($(this).attr("href")=="/pages/sale"){
    $(this).addClass('text-orange');
  }
}); 
    
$('.pro-cat-box').each(function(){
  if($(this).attr("href")=="/pages/sale"){
    $('h4', this).addClass('text-orange');
  }
});
  
  /*
   if($('.pro-cat-box').attr("href")==""){
            alert('I am empty href value');
        }
        */
    
    //$( "#sort-by" ).selectmenu();
   // mobileMenuHeight();
    //equalheight('.equalheight');
    
    $('.search_area, li.search-close').click(function () {
      $('.search-form').toggleClass('form-open');
      
      $(this).children('.iconSearch').toggleClass('icon_search');
      $(this).children('.iconSearch').toggleClass('icon_close');
      $("header .new-search-input").focus();
      
      //$('li.search-close').toggleClass('search-close-show');
      $('li.cart-item').toggleClass('cart-item-hide');
      
      $('body').removeClass('footer-search-on');
    });
    
    /* Product short */
    $('.product-shorting-trigger').click(function () {
        $('#sort-by-list').slideToggle();
        $('.sort-by').toggleClass('active');
        $('body').toggleClass('product-shorting-active');
    });
    
    
    /* Product short Mobile */
    $('.short-trigger, .closeShort').click(function () {
        $('body').toggleClass('active-short');
      $('html').toggleClass('scrollHide');
        
    });
    
     /* Product filter mobile */
    $('.filter-trigger, .closeFilter').click(function () {
        $('body').toggleClass('active-filter');
      $('html').toggleClass('scrollHide');
    });
    
    /* Mobile product details */
    $('.productDetailLink, .closeProductDetails').click(function () {
        $('body').toggleClass('activeProductDetail');
      $('html').toggleClass('scrollHide');
    });
    
    /* Mobile product details */
    $('.productReviewLink, .closeProductReviewLink').click(function () {
        $('body').toggleClass('activeProductReviewLink');
      $('html').toggleClass('scrollHide');
    });

    /* Mobile Shipping & Delivery */
    $('.productShippingLink, .closeProductShippingLink').click(function () {
        $('body').toggleClass('activeProductShippingLink');
      $('html').toggleClass('scrollHide');
    });

    
    $('.navbar .dropdown > a').click(function(){
        location.href = this.href;
    });
    
    $(".dropdown").hover(
        function () {
            $('.dropdown-menu', this).fadeIn("fast");
        },
        function () {
            $('.dropdown-menu', this).fadeOut("fast");
        });


    $('.heroSlider').not('.slick-initialized').slick({
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
      	swipeToSlide: true,
        dots: true,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
      	adaptiveHeight: true
    });

  	$('.heroSlider-ua').not('.slick-initialized').slick({
        prevArrow: false,
        nextArrow: false,
      	swipeToSlide: false,
        dots: false,
        autoplay: false,
        infinite: false,
        autoplaySpeed: 3000,
      	adaptiveHeight: true,
      	touchMove: false,
      	swipe: false
    });
	
  
    $('.offerSlider').not('.slick-initialized').slick({
        dots: false,
        infinite: false,
      	swipeToSlide: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        responsive: [
            {
                breakpoint: 767,
              swipeToSlide: true,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            
        ]
    });
    
    
    /** **/
    $('.colorChoiceSlider').not('.slick-initialized').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
      	swipeToSlide: true,
        infinite:false,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                  swipeToSlide: true,
                    arrows:false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
            
        ]
    });
    
    
    /** **/
 
    
    $('.menu-trigger,.mobile-menu-close').click(function () {
        $('body').toggleClass('slide-active');
    });




    $('span.menu-arrow').click(function () {
        var $thisArrow = $(this);
        $thisArrow.next('.sub-menu').slideToggle(500, function () {
            if ( $thisArrow.closest('li.menu-item').hasClass('active') )
            {
				$thisArrow.closest('li.menu-item').removeClass('active')
            }
			else
            {
				$thisArrow.closest('li.menu-item').addClass('active')
            }
        });
        $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').children('ul.sub-menu').slideToggle(300, function () {
            $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').find('ul.sub-menu').hide();
            $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').removeClass('active');
        });
    });

  	// Open cart on hover
  	/*$("html .cart-item").hover(
        function () {
            $('.cart-box', this).stop().slideToggle();
        },
        function () {
            $('.cart-box', this).stop().slideToggle();
        });
*/
//     $('html.touch .cart-item').click(function () {
//         $('.cart-box').stop().slideToggle();
//     });
 
    
    
    var inputText = $( ".form-control" );
     
    inputText.each(function(){
        //alert(0);
        //console.log($(this).val().length);
        if($(this).val().length != 0 ) {
        
        $(this).parents().addClass('focused');
         //$(inputText).parents('.form-group')('.form-group').addClass('focused');
     }
        
    });
    
    
    
    
    $( ".form-control" ).focus(function() {
        $(this).closest('.form-group').removeClass('focused').addClass('focused');              
    });
    $( ".form-control" ).blur(function() {
        if( $(this).val().length > 0 )
        {
            $(this).closest('.form-group').removeClass('focused').addClass('focused');
        }
        else
        {
            $(this).closest('.form-group').removeClass('focused');                  
        }
        
    });
    
    $( "body" ).on('focus','#hub_contact_div .hs-input',function() {
        $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');              
    });
    $( "body" ).on('blur','#hub_contact_div .hs-input',function() {
        if( $(this).val().length > 0 )
        {
            $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');
        }
        else
        {
            $(this).closest('.hs-form-field').removeClass('focused');                  
        }
        
    });
    
  	$( "body" ).on('focus','#hsForm_0c336e0d-04aa-4961-9a76-ad03815311d1 .hs-input',function() {
        $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');              
    });
    $( "body" ).on('blur','#hsForm_0c336e0d-04aa-4961-9a76-ad03815311d1 .hs-input',function() {
        if( $(this).val().length > 0 )
        {
            $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');
        }
        else
        {
            $(this).closest('.hs-form-field').removeClass('focused');                  
        }
        
    });
  
 
  
  
  
  $("input.form-control").bind('focus', function() {
   $(this).css('background-color', 'white');
});
    
    
    $('.readMore').click(function(){
		var $this = $(this);
		$this.toggleClass('readMore');
		if($this.hasClass('readMore')){
			$this.text('Read More');			
		} else {
			$this.text('Read Less');
		}
	});
    
    
    /**/
    
    $('.product').not('.slick-initialized').slick({
      	swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        //fade: true,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        asNavFor: '.product-nav'
    });
  
    
    
    $('.product-nav').not('.slick-initialized').slick({
      	swipeToSlide: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product',
        dots: false,        
        arrows: false,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        focusOnSelect: true
    });
	
    

	/**/
    
    $(document).on('click', '#close-preview', function(){
    $('.image-preview').popover('hide');
    // Hover befor close the preview
    $('.image-preview').hover(
        function () {
           $('.image-preview').popover('show');
        }, 
         function () {
           $('.image-preview').popover('hide');
        }
    );    
});



    
    // Clear event
    $('body').on('click','.image-preview-clear',function(){
      	var $el = $(this);
        $el.closest('.fu_render').find('.image-show').hide();
        $el.closest('.fu_render').find('.uplodedLogo').hide();
        //$('.image-show #dynamic').remove();
        $el.closest('.fu_render').find('.imageTitle').hide();
        $el.closest('.fu_render').find('.image-preview-filename').val("");
        $el.closest('.fu_render').find('.image-preview-clear').hide();
        $el.closest('.fu_render').find('.image-preview-input input:file').val("");
        $el.closest('.fu_render').find(".image-preview-input-title").text(" Browse"); 
    }); 
  
    // Create the preview image
    $('body').on('change','.image-preview-input input:file',function(){
     var img = $('<img/>', { id: 'dynamic' }); 
      var $el = $(this);
            var file = this.files[0];
            var reader = new FileReader();
            // Set preview image into the popover data-content
            reader.onload = function (e) {
                $el.closest('.fu_render').find('.image-show').show();
                $el.closest('.fu_render').find('.uplodedLogo ').show();
                $el.closest('.fu_render').find(".image-preview-input-title").text(" Change");
                $el.closest('.fu_render').find(".image-preview-clear").show();
                $el.closest('.fu_render').find(".image-preview-filename").val(file.name);
                $el.closest('.fu_render').find(".imageTitle").show().text($(".image-preview-filename").val());
                img.attr('src', e.target.result);
                $el.closest('.fu_render').find('.image-show').show();
              	$el.closest('.fu_render').find('.image-show').html($(img)[0].outerHTML);
                //$(".image-preview").attr("data-content",$(img)[0].outerHTML).popover("show");
            }        
            reader.readAsDataURL(file);
    });


    
    /**/
    
    $('.mobileProductTitle').html($('.productTitle').html());
    $('.mobileProductPrice').html($('.productPriceValue').html());
    //$('.qtyDiscount').html($('.productPriceSecMain').html());
    
 	/*FAqs accordion start*/
		$(".msg_head").click(function (){
			$(this).next(".msg_body").slideToggle();
			$(this).parents(".faqList").toggleClass("active");
          	$(this).parents(".faqList").siblings(".faqList").removeClass("active");
          	$(this).parents(".faqList").siblings(".faqList").find(".msg_body").slideUp();
        });
 /*FAqs accordion close*/

});


// Incrementing product 
$(function () {

    $(".numbers-row").append('<span class="inc button buttnQtyChange arrow_triangle-up"></span><span class="dec button buttnQtyChange arrow_triangle-down"></span>');


    $("body").on("click",".buttnQtyChange", function () {
        newVal = 0;
        var $button = $(this);
        var oldValue = $button.parent().find("input").val()*1;

      	if( $(this).closest('.ProductSizeInfo').length > 0 )
        {
          $(this).parent().find("input").trigger('input');
          // Product Page
          if (!$(this).parents('.ProductSizeInfo').hasClass('outOfStock')) {

              if ($button.hasClass('inc')) {
                  var newVal = parseInt(oldValue) + 1;
                  $(this).parents('.ProductSizeInfo').addClass('selected');
              } else {
                  /** Don't allow decrementing below zero **/
                  if (oldValue > 1) {
                      var newVal = parseInt(oldValue) - 1;
                  } else {
                      newVal = 0;
                      $(this).parents('.ProductSizeInfo').removeClass('selected');
                  }
              }
          } /**/

          $button.parent().find("input").val(newVal);
        }
      	else
        {
          //console.log("DOwn "+oldValue);
          // Cart Page
          if ($button.hasClass('inc')) {
              var newVal = parseInt(oldValue) + 1;
          } else {
            
            /** Don't allow decrementing below zero **/
            if (oldValue > 1) {
              var newVal = parseInt(oldValue) - 1;
            } else {
              newVal = 0;
            }
          }
          $button.parent().find("input").val(newVal);
        }
        

    });

});

$(document).ready(function(){

  //  Mobile special offer top bar show hide
  $('.mobile-offer-close-btn').click(function(){
    $('.topBarMobile').slideToggle();
    createCookie('mobile-top-offer', '0', 1); 
    setTimeout(function(){
      $(window).trigger('resize');
    },500); 
  });
  if( getCookie('mobile-top-offer') == "0" )
  {
     $('.topBarMobile').hide();
  }
  else
  {
     $('.topBarMobile').show();
  }
  
	/*$('body').on('click','input[type=radio]',function(){
		$(this).closest('.shappify_option').find('.shappify_radio_option').removeClass('radioClicked');
		$(this).closest('.shappify_radio_option').addClass('radioClicked');
	});*/
  
  // Save url to cookie on click
  $('.product-upload-logo').click(function(){
	createCookie('product_url_for_logo',$(this).attr('data-save'),1);
    createCookie('product_logo_replacement',$(this).attr('data-logo-placement'),1);
  });
  
  $('.country-flag-toggle li:eq(0)').click(function(){
      $('.country-flag-toggle li:eq(1)').toggle();
      $('.country-flag-toggle').toggleClass('open');
  });
  
});

// Active class adding js for menu

$(window).load(function(){
  $('[data-toggle="tooltip"]').tooltip();
  
  if( location.pathname != "/" )
  {
    if( $(window).width() <= 767 )
    {
      //$('.cursorDefault li a').unwrap();
       // Mobile menu active class script
     	$('.mobile-menu-accordion a').each(function(){
           if( $(this).attr('href') == location.pathname )
           {
             $(this).closest('li').addClass('active');
             $(this).parents('.menu-item').addClass('active');
             $(this).parents('.sub-menu').show();
             $(this).siblings('ul.sub-menu').first().show();
           }
        }); 
      
       setTimeout(function(){
         if( $('.mobile-menu-accordion .active').length == 0 )
         {
            $('.breadcrumb-content-area li').each(function(){
              if( $(this).find('a').attr('href') != "/" && $(this).find('a').attr('href') != "undefined" )
              {
                if( $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').length > 0 )
                {
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').closest('li').addClass('active');
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').parents('.sub-menu').show();
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').siblings('ul.sub-menu').first().show();
                }
              }
            });
       	 }
       },1000); 
    }
    else
    {
      	// Desktop menu active class script
     	$('.main-nav a').each(function(){
            if( $(this).attr('href') == location.pathname )
            {
              // add active class to the parent li of current page
              $(this).closest('li').addClass('active');

              if( $(this).hasClass('dropdown-toggle') )
              {
                // for main menu ( 1st level ) 
              }
              else if ( $(this).closest('ul').find('.dropdown-header').length > 0 )
              {
                // for Grand child  menu ( 3rd level )
                if ( $(this).closest('ul').find('.dropdown-header').length == 1 )
                {
                  $(this).closest('ul').find('.dropdown-header').addClass('active');
                }
                else if( $(this).closest('li').hasClass('dropdown-header') )
                {
                  $(this).closest('li').addClass('active');
                }
                else
                {
                  //$(this).closest('ul').find('.dropdown-header').addClass('active');
                  $(this).closest('li').prev('.dropdown-header').addClass('active');
                }
                	
                $(this).parents('.dropdown').find('.dropdown-toggle').closest('li').addClass('active');
              }	
              else //if( $(this).closest('.dropdown-header').length > 0 )
              {
                // for child  menu ( 2nd level )
                $(this).parents('.dropdown').find('.dropdown-toggle').closest('li').addClass('active');
              }

            }
          });  

          setTimeout(function(){
              if( $('.main-nav .active').length == 0 )
              {
                $('.breadcrumb-content-area li').each(function(){
                   if( $(this).find('a').attr('href') != "/" && $(this).find('a').attr('href') != "undefined" )
                   {
                     if( $('.main-nav a[href="'+$(this).find('a').attr('href')+'"]').length > 0 )
                     {
                          $('.main-nav a[href="'+$(this).find('a').attr('href')+'"]').closest('li').addClass('active');
                     }
                   }
                });
              }
          },1000); 
    }
  }
   
  
  $(window).trigger('resize');
  
  $('body').on('click','.ProductSizeText .icon_circle-empty,.ProductSizeText .size-lable',function(){
    if( !$(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') )
    {
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').addClass('selected');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(1);
    }
    else if( $(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') )
    {
     	$(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').removeClass('selected');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(0);
    }
  });
  
  
});

$('body').on('click','.show-product-details-tab',function(){
	$('html,body').animate({
           scrollTop: eval($('.productTabs .nav-tabs').offset().top-10)
    }, 1000);  
  	$('a[aria-controls="details"]').trigger('click');
});

$('body').on('click','.productReviewLink,.yotpo-questions,.yotpo-nav-tab,.yotpo-nav-tab, .write-review-button, .write-question-button, .write-question-button .y-label,.write-first-review-button,.write-first-question-button',function(){
  setTimeout(function(){
    //$('.write-question-wrapper').show();
    $('.yotpo-footer').show();
    $('.yotpo-footer').hide();
    $('.yotpo-footer').show();
  },1000);
});

/*var $jquery = (typeof $jquery != 'undefined') ? $jquery : $;
$(document).ready(function(){
  setTimeout(function(){ setFooterAutoPos(); }, 1000);
  $( ".form-sec-footer .ui-autocomplete-input:first" ).change(function(){
	 setFooterAutoPos();
  });
});
$(window).resize(function(){
  setTimeout(function(){ setFooterAutoPos(); }, 100);
});

var setFooterAutoPos = function(){
  $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("footer_ui_complete").removeClass("ui_fixed_height");
  $jquery( ".header .ui-autocomplete-input:first" ).autocomplete("widget").addClass("header_ui_complete");
  
  if($(window).width() < 768){
   $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", { my: "left top", at: "left bottom", collision: "none" }); 
  }else if($(window).width() >= 768 && $(window).width() < 982){
   $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
   $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"right bottom-80",at:"right+80 bottom",collision:"none"}); 
  }else{
   $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
   $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"left-25 bottom-80",at:"left bottom",collision:"none"}); 
  }
}*/

$('.search_btn').click(function () {
      //$(this).toggleClass("openclick");
      //$(this).parents("li").addClass("addclass");
      //$(this).parents("li").removeClass("scaleOnHover");
      $('.search-form-footer').toggleClass('form-open');
      
      //$(this).children('.iconSearch').toggleClass('icon_search');
      //$(this).children('.iconSearch').toggleClass('icon_close');
      $(".footer_search .new-search-input").focus();
     
   });
$('.close_search').click(function () {
  $(".footer_search .new-search-input").val('').change();
  $('.search-form-footer').removeClass('form-open');
});

$('.footer-search_btn').click(function(){
	if( $(window).width() > 767 )
      $('body').addClass('footer-search-on');
});
$('.searchFormInner .new-search-input').focus(function(){
	if( $(window).width() > 767 )
      $('body').addClass('footer-search-on');
});
$('.searchFormInner .new-search-input').blur(function(){
	if( $(window).width() > 767 )
      $('body').removeClass('footer-search-on');
});

$('body').on('click','.yotpo-nav-tab',function(){
	var evt = window.document.createEvent('UIEvents'); 
    evt.initUIEvent('resize', true, false, window, 0); 
    window.dispatchEvent(evt)
});

$(document).ready(function(){
	//product detail accordion options
  $('.accord-head').on('click', function(event){
        event.preventDefault();
    	
        if($(this).hasClass('accord-disabled')){
			return false;
        }
        // create accordion variables
        var accordion = $(this);
        var accordionContent = accordion.next('.accord-content');

        // toggle accordion link open class
    	if(accordion.hasClass("open")){
        	accordion.removeClass("open");
    	}else{
     		accordion.addClass("open");
    	}
    
        // toggle accordion content
        accordionContent.slideToggle(500);

   });
   
   /***** start - product option disable enable accordion ********/
  function resetRadioSec(tempSec){
   	 tempSec.find('.shappify_radio_option').removeClass('radioClicked');
  }
  
  function showLogoUploadFile(flgVal){
    if(flgVal == true){
    	$('.main-uploadlogo-container').show();
    }else{
     	$('.main-uploadlogo-container').hide();
    }
  }
  
  function showLogoFileBrowse(){
    $('.main-uploadlogo-container').removeClass('photo-exists').show();
  }
  
  function cancelEditUploadImg(){
   	$('.main-uploadlogo-container').addClass('photo-exists'); 
  }
   
  
  function setPreviewUploadImage(input) { 
    var preview = document.getElementById('preview_uploaded_file');
    if (input.files && input.files[0]) {
      if (!$(input).hasExtension(['.jpg','.jpeg','.png', '.gif'])) {
        $('.main-uploadlogo-container').addClass('invalid-file-error');
	  	$('.upload-logo-invalid-error').show();
      }else{
        $('.upload-logo-invalid-error').hide();
        $('.main-uploadlogo-container').removeClass('invalid-file-error');
        var reader = new FileReader();
        reader.onload = function (e) {
          preview.setAttribute('src', e.target.result);
          $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
        }
        reader.readAsDataURL(input.files[0]);

        var tempUfileName = (input.files[0].name.length > 30) ? input.files[0].name.substring(0,30) + '...' : input.files[0].name;
        $('.main-uploadlogo-container .uploaded-img-name').text(tempUfileName);

        $('#hidden_upload_your_logo_name').val('');
      }
      
    } else {
      //preview.setAttribute('src', 'placeholder.png');
      $('.upload-logo-invalid-error').hide();
      $('.main-uploadlogo-container').removeClass('invalid-file-error');
      $('.main-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
    }
  }
  
  // additional logo -start
  function add_showLogoUploadFile(flgVal){
    if(flgVal == true){
    	$('.additional-uploadlogo-container').show();
    }else{
     	$('.additional-uploadlogo-container').hide();
    }
  }
  
  function add_showLogoFileBrowse(){
    $('.additional-uploadlogo-container').removeClass('photo-exists').show();
  }
  
  function add_cancelEditUploadImg(){
   	$('.additional-uploadlogo-container').addClass('photo-exists'); 
  }
   
  
  function add_setPreviewUploadImage(input) { 
     var preview = document.getElementById('preview_additional_uploaded_file'); 
    
    if (input.files && input.files[0]) {
       if (!$(input).hasExtension(['.jpg', '.jpeg', '.png', '.gif'])) {
	  	$('.upload-logo-second-invalid-error').show();
         $('.additional-uploadlogo-container').addClass('invalid-file-error');
      }else{
        	$('.upload-logo-second-invalid-error').hide();
        	$('.additional-uploadlogo-container').removeClass('invalid-file-error');
          var reader = new FileReader();
          reader.onload = function (e) {
            preview.setAttribute('src', e.target.result);
            $('.additional-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
          }
          reader.readAsDataURL(input.files[0]);

          var tempUfileName = (input.files[0].name.length > 30) ? input.files[0].name.substring(0,30) + '...' : input.files[0].name;
          $('.additional-uploadlogo-container .uploaded-img-name').text(tempUfileName);

       		$('#hidden_additional_second_logo_name').val('');
      }
    } else {
      $('.upload-logo-second-invalid-error').hide();
       $('.additional-uploadlogo-container').removeClass('invalid-file-error');
      //preview.setAttribute('src', 'placeholder.png');
      $('.additional-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
    }
  }
  // additional logo - end
  
  $('.customize-accord  input[type=radio]').on('change',function(){
		$(this).closest('.accord-content').find('.shappify_radio_option').removeClass('radioClicked');
		$(this).closest('.shappify_radio_option').addClass('radioClicked');
  });
  $('.customize-accord  input[type=checkbox]').on('change',function(){
      if($(this).is(":checked")){
        $(this).closest('.shappify_checkbox_option').addClass('checkboxClicked');
      }else{
        $(this).closest('.shappify_checkbox_option').removeClass('checkboxClicked');
      } 
  });
  
  $('.customize-accord  input[type=number], .customize-accord  input[type=text]').on('change',function(){
      if($(this).val() != '' && $(this).val() != '0'){
        $(this).closest('.shappify_input_option').addClass('inputClicked');
      }else{
        $(this).closest('.shappify_input_option').removeClass('inputClicked');
      } 
  });
  
   $('input[name="properties[Decoration type]"]').on('change', function(event){
   		if($('input[name="properties[Decoration type]"]:checked').length > 0 && $('input[name="properties[Decoration type]"]:checked').val() != 'Sample'){
            
          if($('input[name="properties[Select decoration location]"]').length == 1){
            $('input[name="properties[Select decoration location]"]:first').prop('checked','checked').trigger('change'); 
          }
          
            $('.accord-sr-2 .accord-head').next('.accord-content').slideDown(500);
        	$('.accord-sr-2 .accord-head').removeClass('accord-disabled').addClass('open');
            $('.accord-sr-4 .accord-head').removeClass('accord-disabled');
          
        }else{
          	
          	$('.accord-sr-2 .accord-head').next('.accord-content').slideUp(500);
        	$('.accord-sr-2 .accord-head').addClass('accord-disabled').removeClass('open');
          
            $('.accord-sr-4 .accord-head').next('.accord-content').slideUp(500);
        	$('.accord-sr-4 .accord-head').addClass('accord-disabled').removeClass('open');

          	if($('input[name="properties[Select decoration location]"]:checked').length){
              $('input[name="properties[Select decoration location]"]:checked').removeAttr('checked').trigger('change');
            }
          	resetRadioSec($('.accord-sr-2 .accord-head').next('.accord-content'));
          
        }
   }); 

   $('input[name="properties[Select decoration location]"]').on('change', function(event){
     	
   		if($('input[name="properties[Select decoration location]"]:checked').length > 0){
           
            if($('input[name="properties[Add embroidered logo ?]"][data-checked="checked"]').length > 0){
          		$('input[name="properties[Add embroidered logo ?]"][data-checked="checked"]').prop('checked','checked').trigger('change');	    
            }
          
            if($('input[name="properties[Add embroidered logo ?]"]:checked').length < 1){
             $('input[name="properties[Add embroidered logo ?]"][value="Yes"]').prop('checked','checked').trigger('change');
            }
          
            $('.accord-sr-3 .accord-head').next('.accord-content').slideDown(500);
        	$('.accord-sr-3 .accord-head').removeClass('accord-disabled').addClass('open');
          
        }else{
          	
          	$('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
        	$('.accord-sr-3 .accord-head').addClass('accord-disabled').removeClass('open');
          	
          	if($('input[name="properties[Add embroidered logo ?]"]:checked').length){
              var checkedAddLogo  = $('input[name="properties[Add embroidered logo ?]"]:checked');
             	checkedAddLogo.removeAttr('checked');
                checkedAddLogo.trigger('change');
            }
          
          	resetRadioSec($('.accord-sr-3 .accord-head').next('.accord-content'));
        } 
   });
  
  /*$('.accord-sr-3 input').on('change',function(){
    if(!$('.accord-sr-4 .accord-head').hasClass('open')){
     	$('.accord-sr-4 .accord-head').next('.accord-content').slideDown(500);
        $('.accord-sr-4 .accord-head').removeClass('accord-disabled').addClass('open');
    }
  });*/
  
   $('input[name="properties[Add embroidered logo ?]"]').on('change', function(event){
   		if($('input[name="properties[Add embroidered logo ?]"]:checked').length && $('input[name="properties[Add embroidered logo ?]"]:checked').val() == 'Yes'){
           
            showLogoUploadFile(true);  
          
        }else{
          	
           showLogoUploadFile(false); 
        } 
   }); 
  
   $('input[type="file"][name="properties[Upload your logo (2MB max)]"]').on('change', function(event){
     	 
     		setPreviewUploadImage(this); 
   });
  
   $('.main-uploadlogo-container .uploaded-img-editlink').on('click',function(){
    	showLogoFileBrowse();
   })
   
   $('.main-uploadlogo-container .upload-img-cancel-edit').on('click',function(){
    	cancelEditUploadImg();
   })
   
   $('.customize-accord  input[name="properties[checkbox_Upload_additional_logo]"]').on('change',function(){
      if($(this).is(":checked")){
         add_showLogoUploadFile(true);
      }else{
        add_showLogoUploadFile(false);
      } 
   });
  
   $('input[type="file"][name="properties[Upload additional logo]"]').on('change', function(event){ 
     		add_setPreviewUploadImage(this); 
   });
  
   $('.additional-uploadlogo-container .uploaded-img-editlink').on('click',function(){
    	add_showLogoFileBrowse();
   })
   
   $('.additional-uploadlogo-container .upload-img-cancel-edit').on('click',function(){
    	add_cancelEditUploadImg();
   })
   
  
 	//make selected fisrt option in decoration type
   if($('.accord-sr-1 .accord-head.open').length > 0){
     if($('input[name="properties[Decoration type]"]:checked').length < 1 && $('input[name="properties[Decoration type]"]').length > 0){
      	 $('input[name="properties[Decoration type]"]:first').prop('checked','checked').trigger('change');
     }
   }
  
   //show more than 1 screen colors
  $('.need-morethan-1screen').on('click',function(){
    	var targetCls = $(this).attr('data-targetclass');
    	$(this).parent('.need-morethan-1screen-div').hide();
    	
    	$('.'+targetCls).slideDown(500);
  });
  
  // Remove checked checkbox and image field on product optional extras
  $('body').on('click','input[name="properties[Decoration type]"]',function(){
      if( $(this).attr('value') == "Sample" )
      {
          //$('.additional-uploadlogo-container').removeClass('photo-exists');
          $('input[type="file"][name="properties[Upload additional logo]"]').val('');
          $('form#bold-form-options div.customize-accord:last input[type=checkbox]').each(function(){
              //console.log($(this).attr('name'));
              var $thisCheckbox = $(this);
              if( $thisCheckbox.closest('.shappify_checkbox_option').hasClass('checkboxClicked') )
                  $thisCheckbox.closest('.shappify_checkbox_option').trigger('click');

          });
      }
  });
  	
  
   /***** start - product option disable enable accordion ********/
  
  // Registration Empty Field Check 
  $('form#create_customer').submit(function(){
      var regFirstName = $("form#create_customer input[name='customer[first_name]']").val();
      var regLastName = $("form#create_customer input[name='customer[last_name]']").val();
      var regCompany = $("form#create_customer input[name='customer[note][Company]']").val();
      var regEmail = $("form#create_customer input[name='customer[email]']").val();
      var regPassword = $("form#create_customer input[name='customer[password]']").val();
      var regErrorGlag = 0;

      if( regFirstName.isEmpty() )
      {
          regErrorFlag = 1;
          $("form#create_customer input[name='customer[first_name]']").closest('.form-group').addClass('form-has-error');
      }
      else
          $("form#create_customer input[name='customer[first_name]']").closest('.form-group').removeClass('form-has-error');

      if( regLastName.isEmpty() )
      {
          regErrorFlag = 1;
          $("form#create_customer input[name='customer[last_name]']").closest('.form-group').addClass('form-has-error');
      }
      else
          $("form#create_customer input[name='customer[last_name]']").closest('.form-group').removeClass('form-has-error');

      /*if( regCompany.isEmpty() )
      {
          regErrorFlag = 1;
          $("form#create_customer input[name='customer[note][Company]']").closest('.form-group').addClass('form-has-error');
      }
      else
          $("form#create_customer input[name='customer[note][Company]']").closest('.form-group').removeClass('form-has-error');*/

      if( regEmail.isEmpty() )
      {
          regErrorFlag = 1;
          $("form#create_customer input[name='customer[email]']").closest('.form-group').addClass('form-has-error');
      }
      else
          $("form#create_customer input[name='customer[email]']").closest('.form-group').removeClass('form-has-error');

      if( regPassword.isEmpty() )
      {
          regErrorFlag = 1;
          $("form#create_customer input[name='customer[password]']").closest('.form-group').addClass('form-has-error');
      }
      else
          $("form#create_customer input[name='customer[password]']").closest('.form-group').removeClass('form-has-error');

      if( regErrorFlag == 1 )
          return false;
  });

  // Register form : On change error add or remove
  $('body').on('keyup keydown','form#create_customer input',function(){
      var $input = $(this);
      setTimeout(function(){
        if( $input.attr('name') != "customer[note][Company]" )
        {
          if( $input.val().isEmpty() )
          {
              //console.log("IF");
              $input.closest('.form-group').addClass('form-has-error');
          }
          else
          {
              //console.log("else");
              $input.closest('.form-group').removeClass('form-has-error');
          }
        }
      },200);
  });

  // Phone number validation for special characters and other chratacters ( Contact Us Page )
  $("body").on('keydown',"input[name='phone']",function (e) {
      //console.log(e.keyCode);
      // Allow: backspace, delete, tab, escape, enter and plus sign .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 107]) !== -1 ||
           // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
           // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
               // let it happen, don't do anything
               return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
  });
});

//tooltip delay
function delayToolTip(){ 
  originalLeave = $.fn.tooltip.Constructor.prototype.leave;
  $.fn.tooltip.Constructor.prototype.leave = function(obj) {
    var self = obj instanceof this.constructor ?
        obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
    var container, timeout;

    originalLeave.call(this, obj);

    if (obj.currentTarget) {
      container = $(obj.currentTarget).siblings('.tooltip')
      timeout = self.timeout;
      container.one('mouseenter', function() {
        //We entered the actual popover – call off the dogs
        clearTimeout(timeout);
        //Let's monitor popover content instead
        container.one('mouseleave', function() {
          $.fn.tooltip.Constructor.prototype.leave.call(self, self);
        });
      })
    }
  }; 
}